import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledHorizontalForm = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'withBorder' && prop !== 'variant',
})(({ theme, variant, withBorder }) => ({
  padding: '25px',
  paddingTop: '30px',
  paddingBottom: '30px',
  [theme.breakpoints.down('sm')]: {
    padding: '16px',
    paddingTop: '20px',
    paddingBottom: '20px',
  },
  backgroundColor: 'white',
  borderBottom: withBorder ? '1px solid #ccc' : 'none',
  maxWidth: '100%',
  width: '100%',
  ...(variant === 'twoRows'
    ? {
        display: 'block',
      }
    : {
        display: 'flex',
        overflowX: 'auto',
        flexDirection: { xs: 'column', md: 'row' },
        gap: 1,
      }),
}));

const HorizontalForm = ({ children, variant = 'base', withBorder = true, sx = {}, ...props }) => {
  return (
    <StyledHorizontalForm variant={variant} withBorder={withBorder} sx={sx} {...props}>
      {children}
    </StyledHorizontalForm>
  );
};

export default HorizontalForm;
